module.exports = __webpack_public_path__ + "img/content-1.61c2f144.png";